import { render, staticRenderFns } from "./EventViewRegistration.vue?vue&type=template&id=1a7fa782&"
import script from "./EventViewRegistration.vue?vue&type=script&lang=js&"
export * from "./EventViewRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports